export const formatDateOnly = (datetime) => {
  const date = new Date(datetime);
  const format = date.toLocaleDateString();
  return format;
};
